import './App.css';
import Nav from './component/Nav';
import Main from './component/Main';
import Footer from './component/Footer';

function App() {
  return (
    <>
      <Nav />
      <Main />
      <Footer />
    </>
  );
}

export default App;